import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardViewComponent } from './dashboard-view/dashboard-view.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InquiriesByAssignedGroupComponent } from './inquiries-by-assigned-group/inquiries-by-assigned-group.component';
import { InquiriesByAssignedOwnerComponent } from './inquiries-by-assigned-owner/inquiries-by-assigned-owner.component';
import { InquiriesByRequestTypeComponent } from './inquiries-by-request-type/inquiries-by-request-type.component';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { TabViewModule } from 'primeng/tabview';
import { AgGridModule } from '@ag-grid-community/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedModule } from '../common/shared-module';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InquiriesByTrendComponent } from './inquiries-by-trend/inquiries-by-trend.component';
import { DashboardSettingComponent } from './dashboard-setting/dashboard-setting.component';
import { MailboxStatisticsComponent } from './mailbox-statistics/mailbox-statistics.component';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FadingDialogComponent } from './fading-dialog/fading-dialog.component';
import { InboxModule } from '../inbox/inbox.module';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { IntensityHeatmapBulletComponent } from './intensity-heatmap-bullet/intensity-heatmap-bullet.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from '@dchtools/ngx-loading-v18';
import { NgxUiLoaderModule } from 'ngx-ui-loader';


@NgModule({
  declarations: [DashboardViewComponent,
    InquiriesByAssignedGroupComponent,
    InquiriesByAssignedOwnerComponent,
    InquiriesByRequestTypeComponent,
    InquiriesByTrendComponent,
    IntensityHeatmapBulletComponent,
    MailboxStatisticsComponent,
    FadingDialogComponent,
    DashboardSettingComponent,
  ],
  imports: [
    CommonModule,
    OverlayPanelModule,
    ListboxModule,
    TabViewModule,
    DialogModule,
    FormsModule,
    AgGridModule,
    ReactiveFormsModule,
    MultiSelectModule,
    CheckboxModule,
    SharedModule,
    DropdownModule,
    InputSwitchModule,
    AutoCompleteModule,
    ButtonModule,

    InboxModule,
    TooltipModule,
    ToastModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circleSwish,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#021e48',
      secondaryColour: '#021e48',
      tertiaryColour: '#021e48',
      fullScreenBackdrop: true
    }),
    NgxUiLoaderModule,
  ],
  exports: [
    DashboardViewComponent,
    SharedModule,
    FadingDialogComponent
  ]

})
export class DashboardModule { }
